import { Settings } from "@redotech/redo-team-common/team";

export const allowCustomerAccounts = (
  customerAccountSettings: Settings["customerAccounts"],
): boolean => {
  return !!customerAccountSettings?.enabled;
};
